import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Link } from "react-router-dom";

import { Tooltip, Button, CardTitle, CardSubtitle } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/riwayatjabatanService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";
import Shimmer from "react-shimmer-effect";
class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  source;
  historyTable = "historyriwayatangkakreditTableActive";
  defaultOrder = "credit_number_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      totalAK : 0,
      position_name : this.props.position_name_new,//JSON.parse(localStorage.getItem("userdata")).employee_current_position_name,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      pegawai_uuid: this.peg_uuid,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          let totalAK = response.result.reduce((sum, item) => {
            if (item.credit_number_status == 1 && item.credit_number_is_promoted != 1) {
              return sum + (
                parseFloat(item.credit_number_value)
              );
            }
            return sum;
          }, 0);     
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
            totalAK : totalAK
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.activeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
  }
  
  formatBulanIndo(tanggal) {
    const bulanIndo = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ];
  
    const [year, month] = tanggal.split("-");
    return `${bulanIndo[parseInt(month, 10) - 1]} - ${year}`;
  }
  
  columns = [
    // {
    //   key: "employee_fullname",
    //   text: "NIP - Nama",
    //   className: "employee_fullname",
    //   sortable: true,
    //   width: "20%",
    //   cell : (record) => {
    //     return (
    //       record.employee_nip +' - '+record.employee_name
    //     )
    //   }
    // },
    // {
    //   key: "credit_score_decree_number",
    //   text: "No SK",
    //   className: "credit_score_decree_number",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_decree_date",
    //   text: "Periode",
    //   className: "credit_score_decree_date",
    //   sortable: true,
    //   width: "20%",
    //   cell : (record) => {
    //     return(
    //       this.formatBulanIndo(record.credit_score_decree_date)
    //     )
    //   }
    // },
    // {
    //   key: "credit_score_decree_number",
    //   text: "Angka Kredit",
    //   className: "credit_score_decree_number",
    //   sortable: true,
    //   width: "20%",
    //   cell: (record) => {
    //     var total =
    //       parseFloat(record.credit_score_primary) +
    //       parseFloat(record.credit_score_secondary);
    //     return <span>{<label>{total}</label>}</span>;
    //   },
    // },
    // {
    //   key: "credit_score_decree_number",
    //   text: "Nomor SK",
    //   className: "credit_score_decree_number",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_primary",
    //   text: "Total Kredit Baru",
    //   className: "credit_score_primary",
    //   sortable: true,
    //   cell: (record) => {
    //     var total =
    //       parseFloat(record.credit_score_primary) +
    //       parseFloat(record.credit_score_secondary);
    //     return <span>{<label>{total}</label>}</span>;
    //   },
    // },
    // {
    //   key: "credit_score_month_start",
    //   text: "Bulan Mulai Penilaian",
    //   className: "credit_score_month_start",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_decree_date",
    //   text: "Tanggal SK",
    //   className: "credit_score_decree_date",
    //   sortable: true,
    //   width: "20%",
    //   cell: (record) => {
    //     return this.dateParse(record.credit_score_decree_date);
    //   },
    // },
    // {
    //   key: "credit_score_month_end",
    //   text: "Bulan Selesai Penilaian",
    //   className: "credit_score_month_end",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_year_start",
    //   text: "Tahun Mulai Penilaian",
    //   className: "credit_score_year_start",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_primary",
    //   text: "Kredit Utama Baru",
    //   className: "credit_score_primary",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_year_end",
    //   text: "Tahun Selesai Penilaian",
    //   className: "credit_score_year_end",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //   key: "credit_score_secondary",
    //   text: "Kredit Penunjang Baru",
    //   className: "credit_score_secondary",
    //   sortable: true,
    //   width: "20%",
    // },
    // {
    //     key: "position_history_status",
    //     text: "Status",
    //     className: "position_history_status",
    //     sortable: true,
    //     cell: record => {
    //         var  status = record.position_history_status
    //         return (
    //             <span>
    //                 { parseInt(status) == 1 ? <label className="badge rounded-pill bg-soft-success font-size-12" >Aktif</label>: <label><label className="badge rounded-pill bg-soft-danger font-size-12" >Tidak Aktif</label></label> }
    //             </span>
    //         )
    //     }
    // },
    // {
    //   key: "action",
    //   text: "Status",
    //   className: "action",
    //   width: 120,
    //   sortable: false,
    //   align: "center",
    //   cell: (record) => {
    //     const thisId = record.credit_score_uuid;
    //     var status = record.credit_score_status;
    //     return record ? (
    //       record.credit_score_status === 1 ? (
    //         <label className="badge rounded-pill bg-soft-warning font-size-12">
    //           Menunggu Approval Admin
    //         </label>
    //       ) : record.credit_score_status === 2 ? (
    //         <label className="badge rounded-pill bg-soft-success font-size-12">
    //           Disetujui
    //         </label>
    //       ) : (
    //         <label className="badge rounded-pill bg-soft-danger font-size-12">
    //           Ditolak
    //         </label>
    //       )
    //     ) : (
    //       ""
    //     );
    //   },
    // },
    {
        key: "credit_number_position_name",
        text: "Jabatan",
        className: "credit_number_position_name",
        sortable: true,
    },
    {
        key: "credit_number_type_name",
        text: "Tipe",
        className: "credit_number_type_name",
        sortable: true,
    },
    {
        key: "credit_number_period",
        text: "Periode",
        className: "credit_number_period",
        sortable: true,
    },
    {
      key: "credit_number_value",
      text: "Angka Kredit",
      className: "credit_number_value",
      sortable: true,
      cell: (record) => {
        const isPromoted = record.credit_number_is_promoted !== null;

        return (
          <span>
            <label>
              <>
                <div
                  className={`rounded-circle d-inline-block ${
                    isPromoted ? "bg-danger" : "bg-success"
                  }`}
                  style={{
                    width: 12,
                    height: 12,
                    marginRight: 6,
                    verticalAlign: "middle",
                  }}
                />
                {parseFloat(record.credit_number_value)}
              </>
            </label>
          </span>
        );
      },
    },

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.credit_score_uuid;
        var status = record.credit_score_status;
        return status == 1 ? (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.credit_number_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
            <span>
              <button
                className="btn btn-warning btn-sm"
                id={"update-" + thisId}
                onClick={() => {
                  this.setState({
                    updateUuid: record.credit_number_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-edit"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["update" + thisId]}
                target={"update-" + thisId}
                toggle={() => {
                  this.setState({
                    ["update" + thisId]: !this.state["update" + thisId],
                  });
                }}
              >
                Update
              </Tooltip>
            </span>
            <span>
              <button
                className="btn btn-danger btn-sm"
                id={"delete-" + thisId}
                onClick={() => {
                  this.modal_confirm_status = 1;
                  this.modal_confirm_message =
                    "Apakah anda yakin akan menonaktifkan data ini ?";
                  this.setState({
                    inactiveUuid: record.credit_number_uuid,
                    confirm: true,
                  });
                }}
                style={{
                  padding: "2px 5px",
                }}
              >
                <i className="uil-trash-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["delete" + thisId]}
                target={"delete-" + thisId}
                toggle={() => {
                  this.setState({
                    ["delete" + thisId]: !this.state["delete" + thisId],
                  });
                }}
              >
                Nonaktifkan
              </Tooltip>
            </span>
          </Fragment>
        ) : (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.credit_number_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <div className="float-end">
          {
            // (accessRole('create')) && currentRoleId ==  ?
            // <Link to="?riwayat_angkakredit&create">
            //   <Button color="primary">Tambah Riwayat Angka Kredit</Button>
            // </Link>
            // : null
          }
        </div>
        <CardTitle>Daftar Riwayat Angka Kredit Non PKPM</CardTitle>
        {/* <CardSubtitle className="mb-3">
          Kelola Daftar Riwayat Angka Kredit PKPM
        </CardSubtitle> */}
        
        <div className="col-md-6">
          <div className="d-flex gap-4 shadow rounded p-3">
              <div>
                  <p style={{fontSize:"14px", fontWeight:"400", color:"#252525"}}>Jabatan Saat ini</p>
                  <p className="m-0" style={{fontSize:"14px", fontWeight:"600", color:"#252525"}}>
                    {
                      this.state.loadingTable ?
                      <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                      </Shimmer>
                      :
                      this.state.position_name || '-'
                    }
                  </p>
              </div>
              <div>
                  <p style={{fontSize:"14px", fontWeight:"400", color:"#252525"}}>Akumulasi Angka Kredit</p>
                  <p className="m-0" style={{fontSize:"14px", fontWeight:"600", color:"#252525"}}>
                    {
                      this.state.loadingTable ?
                      <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                      </Shimmer>
                      :
                      this.state.totalAK
                    }
                  </p>
              </div>
          </div>
        </div>
         <div className="p-2 bd-highlight float-end">
            <div style={{ paddingTop: 8 }}>
              <div
                className="bg-success rounded-circle d-inline-block"
                style={{ width: 12, height: 12, marginRight: 6, verticalAlign: "middle" }}
              ></div>
              Angka Kredit Baru
            </div>
          </div>

          <div className="p-2 bd-highlight float-end">
            <div style={{ paddingTop: 8 }}>
              <div
                className="bg-danger rounded-circle d-inline-block"
                style={{ width: 12, height: 12, marginRight: 6, verticalAlign: "middle" }}
              ></div>
              Angka Kredit Lama
            </div>
          </div>
          <br/><br/>
        <hr />                    
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/home.html?riwayat_angkakredit&details&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/home.html?riwayat_angkakredit&update&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
